(function () {
    var SECTION_SELECTOR = '[data-mb-single-policy]';
    var LANG_BTN_SELECTOR = '[data-mb-single-policy-lang]';
    var LANG_CONTENT_SELECTOR = '[data-mb-single-policy-lang-content]';

    function initSinglePolicy(root) {
        var langBtns = root.querySelectorAll(LANG_BTN_SELECTOR);

        langBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var lang = btn.getAttribute('data-mb-single-policy-lang');
                setActiveLang(root, lang);
            });
        });
    }

    function setActiveLang(root, lang) {
        /* Update buttons */
        root.querySelectorAll(LANG_BTN_SELECTOR).forEach(function (btn) {
            btn.classList.toggle('active', btn.getAttribute('data-mb-single-policy-lang') === lang);
        });

        /* Show/hide content blocks per language */
        root.querySelectorAll(LANG_CONTENT_SELECTOR).forEach(function (el) {
            var elLang = el.getAttribute('data-mb-single-policy-lang-content');
            el.style.display = elLang === lang ? '' : 'none';
        });
    }

    /* ── Init ── */
    function init() {
        document.querySelectorAll(SECTION_SELECTOR).forEach(initSinglePolicy);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    /* Re-init in Shopify theme editor */
    if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', init);
    }
})();
